import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import * as BlockedPhoneNumberRegisterActions from '../../blocked-phone-number-register-component/state/blocked-phone-number-register.actions';
import { BlockedPhoneNumberDetailSaveModel } from '../models/blocked-phone-number-detail-save.model';
import { AddBlockedPhoneNumberApiService } from '../services/add-blocked-phone-number-api.service';
import * as AddBlockedPhoneNumberActions from './add-blocked-phone-number.actions';

@Injectable()
export class AddBlockedPhoneNumberEffects {
   createBlockedPhoneNumber$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddBlockedPhoneNumberActions.createBlockedPhoneNumber),
         withLatestFrom(this.store.pipe(select(getSelectedAccountId))),
         switchMap(([action, accountId]) => {
            const blockedPhoneNumberToSave: BlockedPhoneNumberDetailSaveModel = {
               ...action.blockedPhoneNumber,
               accountId: accountId,
            };
            return this.addBlockedPhoneNumberApiService.create(blockedPhoneNumberToSave).pipe(
               map((executionResult) => {
                  return AddBlockedPhoneNumberActions.createBlockedPhoneNumberSuccess({
                     blockedPhoneNumberId: executionResult.data.blockedPhoneNumber.blockedPhoneNumberId,
                     phoneNumber: executionResult.data.blockedPhoneNumber.phoneNumber,
                  });
               }),
               catchError((error) => {
                  return of(AddBlockedPhoneNumberActions.createBlockedPhoneNumberFailure(error));
               })
            );
         })
      );
   });

   createBlockedPhoneNumberAndAddAnother$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddBlockedPhoneNumberActions.createBlockedPhoneNumberAndAddAnother),
         withLatestFrom(this.store.pipe(select(getSelectedAccountId))),
         switchMap(([action, accountId]) => {
            const blockedPhoneNumberToSave: BlockedPhoneNumberDetailSaveModel = {
               ...action.blockedPhoneNumber,
               accountId: accountId,
            };
            return this.addBlockedPhoneNumberApiService.create(blockedPhoneNumberToSave).pipe(
               map((executionResult) => {
                  return AddBlockedPhoneNumberActions.createBlockedPhoneNumberAndAddAnotherSuccess({
                     blockedPhoneNumberId: executionResult.data.blockedPhoneNumber.blockedPhoneNumberId,
                     phoneNumber: executionResult.data.blockedPhoneNumber.phoneNumber,
                  });
               }),
               catchError((error) => {
                  return of(AddBlockedPhoneNumberActions.createBlockedPhoneNumberAndAddAnotherFailure(error));
               })
            );
         })
      );
   });

   createBlockedPhoneNumberSuccess$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddBlockedPhoneNumberActions.createBlockedPhoneNumberSuccess),
         switchMap((result) => {
            this.dialogService.closeFormComponent();
            this.snackbar.open(`Phone Number ${result.phoneNumber} Blocked`);
            return of(BlockedPhoneNumberRegisterActions.refreshList());
         })
      );
   });

   createBlockedPhoneNumberAndAddAnotherSuccess$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddBlockedPhoneNumberActions.createBlockedPhoneNumberAndAddAnotherSuccess),
         switchMap((result) => {
            this.snackbar.open(`Phone Number ${result.phoneNumber} Blocked`);
            return of(BlockedPhoneNumberRegisterActions.refreshList());
         })
      );
   });

   constructor(
      private actions$: Actions,
      private store: Store<AppState>,
      private addBlockedPhoneNumberApiService: AddBlockedPhoneNumberApiService,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private router: Router
   ) {}
}
